import { Grid } from '@mui/material'
import { FormSelectField, FormTextField } from '../../../components/FormCore'
import { ControllerTypes, DataTypes } from '../../../enums'
import { ICustomProperty } from '../../../generated-types/customProperty'
import { isJSON } from 'src/utils'
import { resolveCustomPropertyLabel } from 'src/utils/customPropertyValues'

export const CustomMainComponentFields: React.FC<{ customFields: Array<ICustomProperty> }> = ({ customFields }) => {
  return (
    <Grid container pt={1} className="!flex !flex-wrap justify-between">
      {customFields?.map((field, index) => {
        const label = resolveCustomPropertyLabel(field)
        const name = field.id.toString()
        return (
          <Grid item xs={12} md={6} lg={6} key={index}>
            {(field.controllerType === ControllerTypes.TextBox ||
              field.controllerType === ControllerTypes.NumberTextBox) && (
                <FormTextField name={name} label={label} type={field.dataType == DataTypes.Integer ? 'number' : 'text'} />
              )}
            {field.controllerType === ControllerTypes.Dropdown && (
              <FormSelectField
                data={
                  field.dropdownOptions
                    ? isJSON(field.dropdownOptions)
                      ? JSON.parse(field.dropdownOptions)
                      : field.dropdownOptions.split(';').slice(0, -1)
                    : []
                }
                name={name}
                label={label}
              />
            )}
          </Grid>
        )
      })}
    </Grid>
  )
}
